window.setFlatpickr = function () {
  if (typeof feather !== "undefined") {
    feather.replace()
  }
}

window.setBsStepper = function () {}
